import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import renderTextField from '../../components/MaterialUi/renderTextField';
import RFCheckboxField from '../../components/ReduxFormComps/RFCheckboxField';
import RFDatePickerField from '../../components/ReduxFormComps/RFDatePickerField';
import styles from './common/styles';
import InputAdornment from 'material-ui/Input/InputAdornment'
import Paper from 'material-ui/Paper'

class DocFormAdditionalQuestions extends React.Component {
    
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.isOverrideApplicantSignatureDateNotFound !== nextProps.isOverrideApplicantSignatureDateNotFound) {
            return true;
        }
        return false;
    }

    render(){
        const { isOverrideApplicantSignatureDateNotFound } = this.props;
        return (
            <div>
                <Paper>
                    <div className="container">
                        <div className='row'>
                            <div className='col-sm'>
                                &nbsp;
                            </div>
                        </div>    
                        <div className='row'>
                            <div className='col-sm'>
                                <Field
                                    name="heightFeet"
                                    component={renderTextField}
                                    label="Height"
                                    type="number"
                                    style={styles.heightTextFieldStyle}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">Feet</InputAdornment>,
                                        inputProps: { min: 1 , max: 12 }
                                    }}
                                   
                                />
                                
                                &nbsp;
                                
                                <Field
                                    name="heightInches"
                                    component={renderTextField}
                                    label=""
                                    type="number"
                                    style={styles.heightTextFieldStyle}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">Inches</InputAdornment>,
                                        inputProps: { min: 1 , max: 120 }
                                    }}
                                />
                                
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="weight"
                                    component={renderTextField}
                                    label="Weight"
                                    type="number"
                                    style={styles.nameTextFieldStyle}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">lbs</InputAdornment>,
                                    }}
                                />
                            </div> 
                        </div>    
                        <div className='row'>
                            <div className="col-sm">
                                <div style={{paddingTop: '5px',paddingBottom: '5px'}}></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-sm'>
                                <Field 
                                  name="isThereApplicantSignature" 
                                  component={RFCheckboxField} 
                                  label="Is there a signature?" 
                                />
                            </div>
                            <div className='col-sm'>
                                {!isOverrideApplicantSignatureDateNotFound?(
                                    <Field
                                        name="applicantSignatureDate"
                                        component={RFDatePickerField}
                                        label="*Applicant Signature Date"
                                        inputDateFormat='MM/DD/YYYY'
                                        style={styles.nameTextFieldStyle}
                                        inputNote="US date format MM/DD/YYYY"
                                    /> 
                                ):null}    
                                <Field name="isOverrideApplicantSignatureDateNotFound" 
                                component={RFCheckboxField} 
                                label="Applicant Signature Date Not Found in Document" />
                            </div>
                        </div> 
                    </div>
              </Paper>      
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        gorgon: state.gorgon
    }
}

export default connect(mapStateToProps)(DocFormAdditionalQuestions);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocFormAdditionalQuestions.js